var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { useRenameCSS } from "../theme/Theme.js";
import { BodyShort } from "../typography/index.js";
export const DataCell = forwardRef((_a, ref) => {
    var { className, children = "", align, textSize } = _a, rest = __rest(_a, ["className", "children", "align", "textSize"]);
    const { cn } = useRenameCSS();
    return (React.createElement(BodyShort, Object.assign({ as: "td", ref: ref, className: cn("navds-table__data-cell", className, {
            [`navds-table__data-cell--align-${align}`]: align,
        }), size: textSize }, rest), children));
});
export default DataCell;
//# sourceMappingURL=DataCell.js.map